import React, { useState } from 'react';
import NetValueTrendContent from './NetValueTrendContent';
import WidgetAlert, { WidgetErrorType } from 'components/widgetParts/WidgetAlert';
import withQueryWidget, { WithQueryWidgetProps } from 'components/widgetParts/queryWidgetComposition/withQueryWidget';
import { getSingleOriginalRequestByName, getSingleWidgetResponseByName } from 'system/widget/Widget';
import { MakeDrilldownQueryFromHistogramIndex } from 'components/widgets/utility/DrilldownQuery';
import { DashboardQueryDrilldownDialog } from 'components/dialogs/QueryDrilldown/DashboardQueryDrilldownDialog';
import { Query } from 'system/query/Query';

function NetValueTrendWidgetContent(props: WithQueryWidgetProps): JSX.Element {
  const originalRequest = getSingleOriginalRequestByName(props.activeWidgetRequests, 'net-value-trend');
  const apiResponseInfo = getSingleWidgetResponseByName(props.apiResponses, 'net-value-trend');

  const response = apiResponseInfo?.responseBody;
  const request_info = originalRequest?.requestInit;
  const filter = request_info?.body?.aggs?.net_value_trend?.aggs?.net_value?.filter;
  const fieldResponse = response?.net_value_trend;

  const xSeries = fieldResponse?.series?.[0];
  const topSeries = fieldResponse?.series?.find(series => series.key === filter?.[0]);
  const bottomSeries = fieldResponse?.series?.find(series => series.key === filter?.[1]);

  const topValues = topSeries?.values;
  const bottomValues = bottomSeries?.values;

  const xAxisFieldLabel = xSeries?.field_label;
  const xAxisKeys = fieldResponse?.keys;
  const xAxisLabels = fieldResponse?.labels;

  const yFieldLabel = topSeries?.field_label;

  // When one series is missing, zero-pad it to match the x-axis length
  // so NetTrend can still render the available data without NaN values
  const axisLength = xAxisKeys?.length ?? Math.max(topValues.length, bottomValues.length);
  const paddedTopValues = topValues ? topValues : Array(axisLength).fill(0);
  const paddedBottomValues = bottomValues ? bottomValues : Array(axisLength).fill(0);

  const topLabel = topSeries?.label;
  const bottomLabel = bottomSeries?.label;

  const [drilldownTitle, setDrilldownTitle] = useState<string | null>(null);
  const [drilldownQuery, setDrilldownQuery] = useState<Query | null>(null);

  return (
    <>
      {(paddedTopValues.length > 0 && paddedBottomValues.length > 0) &&
      <>
          <NetValueTrendContent
          xFieldLabel= {xAxisFieldLabel}
          xFieldValues = {xAxisKeys}
          xFieldLabels = {xAxisLabels}
          yFieldLabel = {yFieldLabel}

          topLabel={topLabel ?? ''}
          topValues={paddedTopValues}

          bottomLabel={bottomLabel ?? ''}
          bottomValues={paddedBottomValues}

          settingsState = {props.widget?.data?.settings}
          queryDisplayTitle = {apiResponseInfo?.queryDisplayTitle}

          onClick = {(clickedIndex: number) => {
            const drilldownInfo = MakeDrilldownQueryFromHistogramIndex(fieldResponse, xSeries?.field_id, clickedIndex);
            if (drilldownInfo) {
              setDrilldownTitle(`${topLabel} vs ${bottomLabel}: ${drilldownInfo.title}`);
              setDrilldownQuery(drilldownInfo.query);
            }
          }}
          />
      </>
      }
      {(!xAxisKeys?.length) &&
        <WidgetAlert type={WidgetErrorType.NO_DATA} />
      }
      {drilldownQuery && drilldownTitle &&
        <DashboardQueryDrilldownDialog
          title={drilldownTitle}
          queryInfo={props.queryInfo}
          onClose={() => setDrilldownQuery(null)}
          activeQueryIds={apiResponseInfo?.originatingRequest?.activeQueryIds}
          widgetRequestInfo={originalRequest}
          drilldownQuery={drilldownQuery}
        />
      }
    </>
  );
}

export default withQueryWidget(NetValueTrendWidgetContent, {
  hasSettingsDialog: true,
  hasQueryDialog: true
});
